import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '热趣',
      meta: {
        title: '热趣'
      },
      component: () => import('../pages/pc/'),
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        if (flag) {
          next({name: 'wap官网'})
        } else {
          next()
        }
        // window.location.href = '/static/www/index.html'
        // next()
      }
    },
    {
      path: '/act1224',
      name: '双旦活动',
      meta: {
        title: '双旦活动'
      },
      component: () => import('../pages/act/act201031')
    },
    {
      path: '/act_pay',
      name: '充值奖励',
      meta: {
        title: '充值奖励'
      },
      component: () => import('../pages/act/act_pay')
    },
    {
      path: '/2048',
      name: '2048',
      meta: {
        title: '2048小游戏'
      },
      component: () => import('../pages/games/2048/GameWrapper.vue')
    },
    {
      path: '/act0821',
      name: '七夕活动',
      meta: {
        title: '七夕活动'
      },
      component: () => import('../pages/act/act201031')
    },
    {
      path: '/act0520',
      name: '520活动',
      meta: {
        title: '520活动'
      },
      component: () => import('../pages/act/act201031')
    },
    {
      path: '/act0801',
      name: '七夕活动',
      meta: {
        title: '七夕活动'
      },
      component: () => import('../pages/act/act201031')
    },
    {
      path: '/act202510',
      name: '万圣节活动',
      meta: {
        title: '万圣节活动'
      },
      component: () => import('../pages/act/act202510')
    },
    {
      path: '/act0621',
      name: '端午活动',
      meta: {
        title: '端午活动'
      },
      component: () => import('../pages/act/act20623')
    },
    {
      path: '/act202503',
      name: '劳动节活动',
      meta: {
        title: '五一劳动节活动'
      },
      component: () => import('../pages/act/act202503')
    },
    {
      path: '/giftrank',
      name: '排行榜',
      meta: {
        title: '排行榜'
      },
      component: () => import('../pages/act/giftrank')
    },
    {
      path: '/act1111',
      name: '礼物大作战',
      meta: {
        title: '礼物大作战'
      },
      component: () => import('../pages/act/act20918')
    },
    {
      path: '/act202508',
      name: '8月暑期活动',
      meta: {
        title: '8月暑期活动'
      },
      component: () => import('../pages/act/act202508')
    },
    {
      path: '/act20260817',
      name: '七夕鹊桥会',
      meta: {
        title: '七夕鹊桥会'
      },
      component: () => import('../pages/act/act20260817')
    },
    {
      path: '/act20260924',
      name: '中秋活动',
      meta: {
        title: '月圆情更浓·热趣中秋夜'
      },
      component: () => import('../pages/act/act20260924/index')
    },
    {
      path: '/act20260924/box',
      name: '中秋礼盒',
      meta: {
        title: '中秋礼盒'
      },
      component: () => import('../pages/act/act20260924/box')
    },
    {
      path: '/act20261001',
      name: '2026国庆活动',
      meta: {
        title: '2026国庆活动'
      },
      component: () => import('../pages/act/act20261001/index')
    },
    {
      path: '/act20261001/box',
      name: '2026国庆礼盒',
      meta: {
        title: '国庆礼盒'
      },
      component: () => import('../pages/act/act20261001/box')
    },
    {
      path: '/act1001',
      name: '国庆活动',
      meta: {
        title: '国庆活动'
      },
      component: () => import('../pages/act/act201001/index2')
    },
    {
      path: '/act0209',
      name: '新年活动',
      meta: {
        title: '新年活动'
      },
      component: () => import('../pages/act/act201001/index')
    },
    {
      path: '/treasurebox',
      name: '新年活动开宝箱',
      meta: {
        title: '新年活动开宝箱'
      },
      component: () => import('../pages/act/act201001/treasurebox')
    },
    {
      path: '/treasurebox2',
      name: '国庆活动开宝箱',
      meta: {
        title: '国庆活动开宝箱'
      },
      component: () => import('../pages/act/act201001/treasurebox2')
    },
    {
      path: '/act0210',
      name: '新年助威',
      meta: {
        title: '新年助威'
      },
      component: () => import('../pages/act/act210210/index')
    },
    {
      path: '/act0813',
      name: '七夕',
      meta: {
        title: '七夕活动'
      },
      component: () => import('../pages/act/act201031')
    },
    {
      path: '/act0327',
      name: '热趣一周年',
      meta: {
        title: '热趣一周年'
      },
      component: () => import('../pages/act/act201031')
    },
    {
      path: '/recall',
      name: '召回活动',
      meta: {
        title: '召回活动'
      },
      component: () => import('../pages/act/recall')
    },
    {
      path: '/cblist',
      name: '召回排行榜',
      meta: {
        title: '活捉老用户'
      },
      component: () => import('../pages/act/recall/cblist')
    },
    {
      path: '/weeklywish',
      name: '周心愿',
      meta: {
        title: '周心愿'
      },
      component: () => import('../pages/weeklywish')
    },
    {
      path: '/monthlypayment',
      name: '月卡中心',
      meta: {
        title: '月卡中心'
      },
      component: () => import('../pages/monthlyPayment')
    },
    {
      path: '/paymentresult',
      name: '月卡支付结果页面',
      meta: {
        title: '支付结果'
      },
      component: () => import('../pages/monthlyPayment/result')
    },
    {
      path: '/love',
      name: '爱的小屋',
      meta: {
        title: '爱的小屋'
      },
      component: () => import('../pages/lovescabin/')
    },
    {
      path: '/love-anonymous',
      name: '蒙面CP',
      meta: {
        title: '蒙面CP'
      },
      component: () => import('../pages/lovescabin/anonymous')
    },
    {
      path: '/lovev2',
      name: '爱的小屋2',
      meta: {
        title: '爱的小屋'
      },
      component: () => import('../pages/lovescabin/lovev2')
    },
    {
      path: '/loverank',
      name: '小屋广场',
      meta: {
        title: '小屋广场'
      },
      component: () => import('../pages/lovescabin/loverank')
    },
    // {
    //   path: '/loveBg',
    //   name: '爱的小屋更换背景',
    //   meta: {
    //     title: '爱的小屋'
    //   },
    //   component: () => import('../pages/lovescabin/lovechangebg')
    // },
    {
      path: '/loveBg2',
      name: '爱的小屋更换背景',
      meta: {
        title: '爱的小屋'
      },
      component: () => import('../pages/lovescabin/lovechangebg2')
    },
    {
      path: '/blesshistory2',
      name: '祝福列表2',
      meta: {
        title: '祝福列表'
      },
      component: () => import('../pages/lovescabin/blesshistory2')
    },
    {
      path: '/blesshistory',
      name: '祝福列表',
      meta: {
        title: '祝福列表'
      },
      component: () => import('../pages/lovescabin/blesshistory')
    },
    // {
    //   path: '/charge',
    //   name: '热趣充值',
    //   meta: {
    //     title: '充值'
    //   },
    //   component: () => import('../pages/charge/'),
    //   beforeEnter: (to, from, next) => {
    //     var code = to.query.code
    //     var local = window.location.href
    //     if (code == null || code === '') {
    //       window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx95824a411304e7fd&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect'
    //     } else {
    //       next()
    //     }
    //   }
    // },
    {
      path: '/charge',
      name: '热趣充值',
      meta: {
        title: '充值'
      },
      component: () => import('../pages/charge/'),
      beforeEnter: (to, from, next) => {
        var code = to.query.code
        var local = window.location.href
        if (code == null || code === '') {
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6a4a3dbc543c8a1a&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect'
        } else {
          next()
        }
      }
    },
    {
      path: '/membershipcharge',
      name: '热趣会员充值',
      meta: {
        title: '会员充值'
      },
      component: () => import('../pages/membershipcharge/'),
      beforeEnter: (to, from, next) => {
        var code = to.query.code
        var local = window.location.href
        if (code == null || code === '') {
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx95824a411304e7fd&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect'
        } else {
          next()
        }
      }
    },
    {
      path: '/withdraw',
      name: '热趣提现',
      meta: {
        title: '魅力提现'
      },
      component: () => import('../pages/withdraw/')
    },
    {
      path: '/invite',
      name: '分享赚钱',
      meta: {
        title: '分享赚钱'
      },
      component: () => import('../pages/invite/')
    },
    {
      path: '/privacy',
      name: '隐私协议',
      meta: {
        title: '隐私协议'
      },
      component: () => import('../pages/privacy/')
    },
    {
      path: '/privacyv2',
      name: '隐私协议',
      meta: {
        title: '隐私协议'
      },
      component: () => import('../pages/privacy/new')
    },
    {
      path: '/agreement',
      name: '用户协议',
      meta: {
        title: '用户协议'
      },
      component: () => import('../pages/agreement/')
    },
    {
      path: '/agreementv2',
      name: '用户协议',
      meta: {
        title: '用户协议'
      },
      component: () => import('../pages/agreement/new')
    },
    {
      path: '/sharingagreement',
      name: '共享经济服务协议',
      meta: {
        title: '共享经济服务协议'
      },
      component: () => import('../pages/sharingagreement/')
    },
    {
      path: '/hwagreement',
      name: '用户协议',
      meta: {
        title: '用户协议'
      },
      component: () => import('../pages/agreement/hwindex')
    },
    {
      path: '/alipaycharge',
      name: '充值',
      meta: {
        title: '充值'
      },
      component: () => import('../pages/alipaycharge/')
    },
    {
      path: '/anchorsigning',
      name: '主播签约',
      meta: {
        title: '主播签约'
      },
      component: () => import('../pages/anchorsigning/')
    },
    {
      path: '/anchorprogress',
      name: '主播进度',
      meta: {
        title: '进度查询'
      },
      component: () => import('../pages/anchorprogress/')
    },
    {
      path: '/aliface',
      name: '认证结果',
      meta: {
        title: '认证结果'
      },
      component: () => import('../pages/aliface/')
    },
    {
      path: '/usercharmlog',
      name: '魅力值明细',
      meta: {
        title: '魅力值明细'
      },
      component: () => import('../pages/usercharmlog/')
    },
    {
      path: '/luckydrawintro',
      name: '大转盘玩法介绍',
      meta: {
        title: '玩法介绍'
      },
      component: () => import('../pages/luckydrawintro/')
    },
    {
      path: '/supervipintro',
      name: '大转盘黑金专区介绍',
      meta: {
        title: '黑金专区兑换介绍'
      },
      component: () => import('../pages/luckydrawintro/supervipintro')
    },
    {
      path: '/landingpage',
      name: '分享落地页',
      meta: {
        title: '热趣'
      },
      component: () => import('../pages/landingpage/')
    },
    {
      path: '/platformconvention',
      name: '平台公约',
      meta: {
        title: '平台公约'
      },
      component: () => import('../pages/landingpage/platformconvention')
    },
    {
      path: '/download',
      name: 'ios版本下载',
      meta: {
        title: 'ios版本下载'
      },
      component: () => import('../pages/landingpage/iosdownload')
    },
    {
      path: '/sms',
      name: '召回短信',
      meta: {
        title: '敢聊App'
      },
      component: () => import('../pages/landingpage/sms')
    },
    {
      path: '/callback',
      name: '召回落地页',
      meta: {
        title: '敢聊App'
      },
      component: () => import('../pages/landingpage/ldcallback')
    },
    {
      path: '/wap',
      name: 'wap官网',
      meta: {
        title: '热趣'
      },
      component: () => import('../pages/wap/')
    },
    {
      path: '/testflight',
      name: 'testFlight',
      meta: {
        title: '热趣'
      },
      component: () => import('../pages/testflight/')
    },
    {
      path: '/project',
      name: 'project',
      meta: {
        title: '购买礼物'
      },
      component: () => import('../pages/fakepage/project/')
    },
    {
      path: '/play',
      name: 'play',
      meta: {
        title: '大冒险'
      },
      component: () => import('../pages/fakepage/play/')
    },
    // {
    //   path: '/aliface',
    //   name: 'aliface',
    //   meta: {
    //     title: '实名认证'
    //   },
    //   component: () => import('../pages/fakepage/aliface/')
    // },
    {
      path: '/thirdPartyGameBuyu',
      name: '捕鱼游戏',
      meta: {
        title: '捕鱼达人'
      },
      component: () => import('../pages/thirdPartyGame/buyu')
    },
    {
      path: '*',
      name: 'notFound',
      component: () => import('../components/404')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js